console.log("This site was generated by Hugo.");

document.addEventListener("DOMContentLoaded", function () {
  (function () {
    var items = Array.prototype.slice.call(document.querySelectorAll(".gallery-item"));
    var lightbox = document.getElementById("lightbox");
    if (!items.length || !lightbox) return;

    var img = lightbox.querySelector(".lightbox__image");
    var caption = lightbox.querySelector(".lightbox__caption");
    var current = 0;

    function show(index) {
      current = (index + items.length) % items.length;
      var item = items[current];
      img.src = item.getAttribute("data-full");
      img.alt = item.getAttribute("data-alt") || "";
      caption.textContent = item.getAttribute("data-caption") || "";
      lightbox.hidden = false;
    }

    function close() {
      lightbox.hidden = true;
      img.src = "";
    }

    items.forEach(function (item, index) {
      item.addEventListener("click", function () {
        show(index);
      });
    });

    lightbox.querySelector("[data-lightbox-close]").addEventListener("click", close);
    lightbox.querySelector("[data-lightbox-prev]").addEventListener("click", function () {
      show(current - 1);
    });
    lightbox.querySelector("[data-lightbox-next]").addEventListener("click", function () {
      show(current + 1);
    });

    lightbox.addEventListener("click", function (e) {
      if (e.target === lightbox) close();
    });

    document.addEventListener("keydown", function (e) {
      if (lightbox.hidden) return;
      if (e.key === "Escape") close();
      if (e.key === "ArrowLeft") show(current - 1);
      if (e.key === "ArrowRight") show(current + 1);
    });
  })();

  (function () {
    var filterBar = document.getElementById("gallery-filter");
    var grid = document.getElementById("gallery-grid");
    if (!filterBar || !grid) return;

    var buttons = Array.prototype.slice.call(filterBar.querySelectorAll("[data-tag-filter]"));
    var cards = Array.prototype.slice.call(grid.querySelectorAll("[data-tags]"));

    function applyFilter(tag) {
      cards.forEach(function (card) {
        var tags = (card.getAttribute("data-tags") || "").split(",");
        card.hidden = tag !== "" && tags.indexOf(tag) === -1;
      });
      buttons.forEach(function (btn) {
        btn.classList.toggle("is-active", btn.getAttribute("data-tag-filter") === tag);
      });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        applyFilter(btn.getAttribute("data-tag-filter"));
      });
    });
  })();

  (function () {
    var toggle = document.getElementById("search-toggle");
    var overlay = document.getElementById("search-overlay");
    if (!toggle || !overlay) return;

    var input = document.getElementById("search-input");
    var resultsList = document.getElementById("search-results");
    var noResultsText = resultsList.getAttribute("data-no-results") || "";
    var indexUrl = overlay.getAttribute("data-search-index");
    var data = null;

    function open() {
      overlay.hidden = false;
      input.focus();
      if (data === null) {
        fetch(indexUrl)
          .then(function (res) {
            return res.json();
          })
          .then(function (json) {
            data = json;
            render(input.value);
          })
          .catch(function () {
            data = [];
          });
      }
    }

    function close() {
      overlay.hidden = true;
      input.value = "";
      resultsList.innerHTML = "";
    }

    function render(query) {
      resultsList.innerHTML = "";
      var term = query.trim().toLowerCase();
      if (!term || !data) return;

      var matches = data.filter(function (item) {
        var haystack = (item.title + " " + item.summary + " " + (item.tags || []).join(" ")).toLowerCase();
        return haystack.indexOf(term) !== -1;
      }).slice(0, 10);

      if (!matches.length) {
        var empty = document.createElement("li");
        empty.className = "search-results__empty";
        empty.textContent = noResultsText;
        resultsList.appendChild(empty);
        return;
      }

      matches.forEach(function (item) {
        var li = document.createElement("li");
        var a = document.createElement("a");
        a.href = item.url;
        var title = document.createElement("span");
        title.textContent = item.title;
        a.appendChild(title);
        if (item.summary) {
          var summary = document.createElement("span");
          summary.className = "search-result__summary";
          summary.textContent = item.summary;
          a.appendChild(summary);
        }
        li.appendChild(a);
        resultsList.appendChild(li);
      });
    }

    toggle.addEventListener("click", open);
    overlay.querySelector("[data-search-close]").addEventListener("click", close);
    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) close();
    });
    input.addEventListener("input", function () {
      render(input.value);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !overlay.hidden) close();
    });
  })();
});
